import React from 'react';
import { getSolicitationInfoPdf } from '../../../utils/fileDownload';

export const columns = [
  {
    Header: 'Solicitation',
    accessor: 'solicitation',
    Cell: cellProps => (
      // const href = cellProps.value.split('-').pop();
      <span>
        <a href="#" onClick={() => { getSolicitationInfoPdf(`${cellProps.value}`) }}  > {cellProps.value} </a>
      </span>
    ),
  },
  {
    Header: 'Status',
    accessor: 'status'
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
  },
  {
    Header: 'UI',
    accessor: 'um',
  },
  {
    Header: 'Closes',
    accessor: 'closes',
  },
  {
    Header: 'Small',
    accessor: 'small',
  },
];

export default {
  columns,
};



// WEBPACK FOOTER //
// ./src/components/grids/RecentSolicitations/gridConfig.jsx